import Api from '../../../../lib/api';

export const getImportHistory = async (importId, authToken) => {
  const urlQuery = `cf/ambest/importDetail?importId=${importId}`;
  try {
    return await Api.get(urlQuery, authToken);
  } catch (e) {
    console.error('Could not fetch AM Best imports');
  }
}